import React, {useState, useEffect} from 'react';
import {useModel} from '../../helpers/model/use_model.js';
import {useSize} from '../../helpers/use_size.js';
import Transformation from '../../helpers/math/transformation.js';
import {Countries} from './countries.js';
import {Bubbles} from './bubbles.js';
import {GeoModel} from './geo-model.js';
import {KashmirBorder} from './kashmir-border.js';

const styleSvg = {};

function BubbleMap(props) {
    const modelInterface = useModel(GeoModel, (m) => (m.getInterface()), {});
    const [size, measuredRef] = useSize((w, h) => ({width: w, height: h}), {width: 1, height: 1});
    const [mapHeight, setMapHeight] = useState(200);
    const width = size.width;
    let height = props.height === 'full' ? size.height :
        (props.height === 'auto' ? mapHeight : props.height);
    if (props.margin.bottom) {
        height -= props.margin.bottom;
    }

    const transform = new Transformation(0.5 * width, 0.55 * height, 0.85);
    const matrix = transform.getTransformationString();

    // update this stuff after the render cylce has finished
    useEffect(() => {
        if (modelInterface.status === GeoModel.Status.SUCCESS) {
            modelInterface.data.setMaxSize(width, height);
            modelInterface.data.setViewData({
                dimension: props.dimension,
                filter: props.filter
            });
            if (props.height === 'auto') {
                modelInterface.data.setHeightCallback(
                    (height) => {
                        if (mapHeight !== (height || 0)) {
                            setMapHeight({height: height || 0});
                        }
                    }
                );
            }
        }
         });

    let condSvgProps = {}
    if(props.svgRef){
        condSvgProps.ref = props.svgRef
    }
    return <div ref={measuredRef} className={props.className}>
        <svg id={'zol-svg'} {...condSvgProps} width={width + 'px'} height={(height) + 'px'}
             viewBox={'0 0 ' + width + ' ' + height}
             style={styleSvg}>
            <defs>
                <clipPath id="cut-off-map">
                    <rect x={-0.5 * width} y={-0.5 * height} width={width} height={height}/>
                </clipPath>
            </defs>
            <g transform={matrix}>
                {/* onMouseLeave of a country shape is not always triggered correctly, so when the mouse
                    is on top of the ocean, clear out any selection */}
                <rect x={-0.5 * width} y={-0.5 * height} width={width} height={height}
                        onMouseEnter={props.onMouseLeave} style={{fill: 'transparent'}}/>

                <g clipPath="url(#cut-off-map)">

                    <Countries onSelect={(country)=>props.onSelect(country)}
                               onMouseEnter={(country)=>props.onMouseEnter(country)}
                               onMouseLeave={props.onMouseLeave}
                               data={props.data}
                               getCountryClass={props.getCountryClass}
                               color={props.color}/>
                    
                    {/* Temporary solution to render a border inside disputed region of Kashmir which
                        seperates Indian and Pakistani controlled areas */}
                    <KashmirBorder />
                </g>

                <Bubbles data={props.data}
                        state={props.state}
                        dimension={props.dimension}
                        onSelect={(key,value)=>props.onSelect({[key]: value})}
                        onMouseEnter={(country)=>props.onMouseEnter(country)}
                        onMouseLeave={props.onMouseLeave}
                        mapSize={[width, height]}/>
            </g>
        </svg>
    </div>

}


BubbleMap.defaultProps = {
    className: 'zol-map',
    dimension: 'region',
    filter: false,
    onSelect: function () {
    },
    maxHeight: false,
    getCountryClass: (country) => (''),
    margin: {},
    data: [
        {
            title: 'Africa',
            region: 'Africa',
            percentage: 0.45,
            color: '#6b91cb',
            value: '45%'
        },
        {
            title: 'Europe',
            region: 'Europe',
            percentage: 0.35,
            value: '35%',
            color: '#41448c'
        },
        {
            title: 'Asia',
            region: 'Asia',
            percentage: 0.20,
            value: '20%',
            color: '#ce5c3c'
        }
    ]
};

export {BubbleMap};
